import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import {
  CondicionForma,
  ConfirmComponent,
  BaseControl,
  Forma,
  SubForma,
  AsociacionTareaForma,
  CondicionControl,
  Control,
  TipoControl,
  EstructuraEspecifica,
  ValoresEspecificos,
  ColumnaMaestra,
  TablaMaestra
} from '@app/shared';
import { CondictionComponentConfig } from './shared/condiction.config.service';
import { CondictionsFormsService } from './shared/condition.forms.service';
import { CondictionDataService } from './shared/condiction-data.service';
import { LocalDataSource } from 'ng2-smart-table';
import { find } from 'lodash';
import { Subject } from 'rxjs';
import { InformacionTablaMaestra } from '@app/shared';

@Component({
  selector: 'iw-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss'],
  providers: [CondictionsFormsService, CondictionDataService]
})
export class ConditionsComponent implements OnInit, OnDestroy {
  // entrada de datos de tablas maestras
  @Input() masterTables: TablaMaestra[] = [];
  // Entrada de las condiciones
  @Input() form: Forma;
  // Define cuando son las condiciones de los controles
  @Input() control = false;
  // Contiene el formulario del control
  @Input() formulario: Array<Control> = [];
  // Contiene el control a condicionar
  @Input() controlCondiction: Control;
  // Contiene los campos a mostrar de la maestra seleccionada
  masterT: InformacionTablaMaestra;
  // Contiene el id de la maestra selccionada
  tablaMaestraSelectedId: number;
  // Contiene el id de la columna maestra selccionada (Columna maestra)
  tablaMaestraSelectedColumnId: number;
  // Contiene la seleccion del campo validar columna
  validarColumna = false;
  // Contiene contiene el valor de la condicion de la maestra
  valorCondicionMaestra = false;
  // Contiene la el id de la columna maestra selccionada (columna condicionar)
  columnaCondicionar: number;
  // Contiene la el id de la columna maestra selccionada (Valor referencia)
  valorReferencia: any = null;
  // Contiene la seleccion del campo operar resultado
  operarResultado = false;
  // Contiene la seleccion del campo de mantener valor en sesion
  mantenerSesion = false;
  // Mensaje de la accion a realizar en el formulario de condicion
  actionForm = '';
  // Forma temporalmete seleccionada
  formSelectedInit = '';
  // Formulario temporalmete seleccionado
  formularioSelectedInit = '';
  // Campo temporalmente seleccionado
  selectedFieldInit = '';
  // Formulario temporalmete seleccionado para condicionar
  formularioSelectedCondictional = '';
  // Campo temporalmente seleccionado
  selectedFieldCondictional = '';
  // Operador condicional seleccionado temporalmente
  selectedSiEs = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Index del registro de condicion seleccionado
  indexSelected = -1;
  // Define cuando se muestra el formulario para agregar o modificar la condicion
  formCondiction = false;
  // Define cuando se modifica la condicion o se agrega una nueva
  condictionEdit = false;
  // Configuracion de la tabla
  settings = {};
  // Condiciones de las formas
  formsCondictions: Array<CondicionForma> = [];
  // Condiciones de los formulario
  formulariosCondictions: Array<CondicionControl> = [];
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Contiene las asociaciones de las formas
  formsAssociations: Array<AsociacionTareaForma> = [];
  // Contiene los formularios de la forma actual
  formularios: Array<SubForma> = [];
  // Formas iniciales
  formInitials: Array<{key: string, value: string}> = [];
  // Formularios iniciales
  formulariosInit: Array<{key: string, value: string}> = [];
  // Campos iniciales
  fieldInit: Array<{key: string, value: string}> = [];
  // Formularios a condicionar
  formCondictions: Array<{key: string, value: string}> = [];
  // Campos a condicionar
  fieldCondictions: Array<{key: string, value: string}> = [];
  // Contiene las consultas de las columnas de las maestras
  acomulateColumns: Array<{
    name: string,
    columns: ValoresEspecificos[],
  }> = [];
  // Forma condicional seleccionada
  formsCondictionals: Array<Forma> = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Condicion seleccionada
  condictionSelect: CondicionForma;
  // Condicion temporal para el cambio de el formulario
  condictionTemp: CondicionForma;
  // Condicion seleccionada
  condictionFormularioSelect: CondicionControl;
  // Condicion temporal para el cambio de el formulario
  condictionFormularioTemp: CondicionControl;
  // Contiene las opciones del formulario de condiciones
  options: any = {};
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Salida del evento de guardar las condiciones
  @Output() saveCondictions: EventEmitter<Array<any>> = new EventEmitter();

  @Output() condictions: EventEmitter<Array<CondicionControl>> = new EventEmitter();
  // salida que valida la pestaña condiciones y operaciones
  @Output() conditionOperations: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private cfs: CondictionsFormsService,
    private cds: CondictionDataService,
  ) { }

  ngOnInit() {
    if (this.form) {
      if (this.form.condiciones && this.form.condiciones.length) {
        this.form.condiciones.forEach(condiction => {
          this.formsCondictions.push(condiction);
        });
      }

      if (this.form.alias) {
        this.formInitials.push({
          key: this.form.alias,
          value: this.form.alias
        });
      }

      if (this.form.asociaciones && this.form.asociaciones.length) {
        this.formsAssociations = this.form.asociaciones;
        this.formsAssociations.forEach(association => {
          this.formInitials.push({
            key: association.aliasAsociacion,
            value: association.aliasAsociacion,
          });
        });
      }

      if (this.form.sub_formas && this.form.sub_formas.length) {
        this.formularios = this.form.sub_formas;
        this.formularios.forEach(formulario => {
          if (formulario.alias) {
            this.formCondictions.push({
              key: formulario.alias,
              value: formulario.alias,
            });
          }
        });
      }
      this.options = {
        formCondictions: this.formCondictions,
        formInitials: this.formInitials
      };
    } else if (this.formulario) {

      if (this.controlCondiction) {
        if (
          this.controlCondiction.validaciones &&
          this.controlCondiction.validaciones.condiciones &&
          this.controlCondiction.validaciones.condiciones.length
        ) {
          this.controlCondiction.validaciones.condiciones.forEach(condiction => {
            const controlTem = find(this.formulario, {nombre_campo: condiction.campoDepende});
            if (controlTem) {
              condiction.campoDepende = controlTem.alias;
            }
            this.formulariosCondictions.push(condiction);
          });
        }
      }

      this.formulario.forEach(field => {
        if (!this.controlCondiction || this.controlCondiction.alias !== field.alias) {
          if (field.alias) {
            this.fieldInit.push({
              key: field.alias,
              value: field.alias,
            });
          }
        }
      });
      if (this.fieldInit && this.fieldInit.length) {
        this.options = {
          fieldInit: this.fieldInit
        };
      }
    }

    const configTable = new CondictionComponentConfig();
    if (this.control) {
      this.settings = configTable.getTableCondictionsControl();
    } else {
      this.settings = configTable.getTableCondictionsForm();
    }
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });

    this.loadingCondictions();
    this.cfs.masterTables = this.masterTables;
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Define la accion a realizar para el registro de una condicion
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ConditionsComponent
   */
  async defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.formCondiction = true;
        this.condictionEdit = false;
        this.actionForm = 'Agregar';
        if (!this.control) {
          this.controls = this.cfs.getFormCondiction(this.ngSelectTpl, this.options);
        } else {
          this.controls = this.cfs.getFormCondictionControl(this.ngSelectTpl, this.options);
        }
        break;
      case 'update':
        this.formCondiction = true;
        this.condictionEdit = true;
        this.actionForm = 'Modificar';
        if (!this.control) {
          this.condictionSelect = data;
          this.indexSelected = this.condictionSelect.index;
          this.condictionTemp = data;
          this.selectedFieldInit = this.condictionSelect.campoInicia;
          this.formSelectedInit = this.condictionSelect.formaInicia;
          this.formularioSelectedInit = this.condictionSelect.formularioInicia;
          this.formularioSelectedCondictional = this.condictionSelect.formularioCondicionado;
          this.selectedFieldCondictional = this.condictionSelect.campoCondicionado;
          this.getFormulariosForm(false);
        } else {
          this.condictionFormularioSelect = data;
          this.indexSelected = this.condictionFormularioSelect.index;
          this.condictionFormularioTemp = data;
          if (data.accion !== null) {
            this.cfs.tablaMaestraSelectedId = data.maestra;
            this.cfs.tablaMaestraSelectedColumnId = data.columnaMaestra;
            this.cfs.validarColumna = data.validarColumna;
            this.cfs.columnaCondicionar = data.columnaCondicionar;
            this.conditionOperations.emit(data.columnaCondicionar);
            this.cfs.valorCondicionMaestra = data.valorMaestra;
            this.cfs.valorReferencia = data.valorReferencia;
            this.cfs.operarResultado = data.operarResultado;
            this.cfs.mantenerSesion = data.mantenerSesion;
            if ( data.maestra !== null && data.maestra != undefined) {
              this.masterT = await this.cds.getInformacionMasterTable(Number(data.maestra));
              this.cfs.masterTablesField = this.masterT;
            }
          }
          this.selectedFieldInit = this.condictionFormularioSelect.campoDepende;
          await this.refreshFormCondiction(false, 'inicial');
          await this.refreshFormCondiction(false, 'condicionado');
        }
        break;
      case 'delete':
        if (!this.control) {
          this.condictionSelect = data;
          this.indexSelected = this.condictionSelect.index;
        } else {
          this.condictionFormularioSelect = data;
          this.indexSelected = this.condictionFormularioSelect.index;
        }
        this.question = '¿Realmente desea eliminar la condición?';
        this.confirm.open();
        break;
    }
  }

  /**
   * Cierra el formulario de edicion o creacion de la condicion
   *
   * @memberof ConditionsComponent
   */
  closeFormCondiction() {
    this.formCondiction = false;
    this.formSelectedInit = '';
    this.formularioSelectedInit = '';
    this.selectedFieldInit = '';
    this.selectedFieldCondictional = '';
    this.formularioSelectedCondictional = '';
    this.selectedSiEs = '';
    delete this.condictionTemp;
    delete this.condictionFormularioTemp;
    delete this.formulariosInit;
    delete this.fieldCondictions;
    this.conditionOperations.emit(false);
    if (!this.control) {
      delete this.fieldInit;
      this.options = {
        formCondictions: this.formCondictions,
        formInitials: this.formInitials
      };
    } else {
      this.options = {
        fieldInit: this.fieldInit
      };
    }
    if (this.condictionEdit) {
      this.indexSelected = -1;
      this.condictionEdit = false;
      delete this.condictionSelect;
      delete this.condictionFormularioSelect;
    }
  }

  /**
   * Guarda o edita el registro de condicion
   *
   * @param {*} data
   * @memberof ConditionsComponent
   */
  sended(data: any) {
    const moment = require('moment');
    let date = false;
    if (data.txtValor && moment(new Date(data.txtValor)).isValid()) {
      date = true;
    } else if (data.chFechaActual) {
      date = true;
    }
    let field: Control;
    let fieldCondictional: Control;
    if (!this.control) {
      const newCondiction: CondicionForma = {
        formaInicia: data.cboFormInit,
        formularioInicia: data.cboFormularioInit,
        campoInicia: data.cboFieldInit,
        siEs: data.cboSiEs,
        valor: data.txtValor,
        fechaActual: data['txtValor_chFechaActual'],
        accion: data.cboAction,
        valorAsignar: data.txtValorAsignar,
        fechaActualAsignar: data['txtValorAsignar_chFechaActual'],
        formularioCondicionado: data.cboFormularioCondiction,
        campoCondicionado: data.cboFieldCondiction,
        maestra: data.cbSelectMaestra,
        columnaMaestra: data.cbColumnaMaestra,
        columnaCondicionar: data.cbColumnaCondicionar,
        valorMaestra: data.txtValorMaestra,
        valorReferencia: data.cbValorReferencia,
        operarResultado: data.chOperarResultado,
        mantenerSesion: data.chMantenerSesion,
        validarColumna: data.chValidarColumna,
        operadorCondicion: data.cboOperactorNext
      };
      let form: SubForma;
      if (this.form.alias === this.formSelectedInit) {
        form = find(this.form.sub_formas, {alias: this.formularioSelectedInit});
      } else {
        const association = find(this.formsAssociations, {aliasAsociacion: this.formSelectedInit});
        if (association) {
          const formcondictionalSeleted = find(this.formsCondictionals, {id: association.idForma});
          if (formcondictionalSeleted) {
            form = find(formcondictionalSeleted.sub_formas, {alias: this.formularioSelectedInit});
          }
        }
      }
      if (form) {
        field = find(form.campos, {alias: this.selectedFieldInit});
      }
      const formCondictional = find(this.form.sub_formas, {alias: this.formularioSelectedCondictional});
      if (formCondictional) {
        fieldCondictional = find(formCondictional.campos, {alias: this.selectedFieldCondictional});
      }
      if (field) {
        this.getValueSelect(
          data,
          newCondiction,
          'txtValor',
          'txtValor_chFechaActual',
          'textSelect',
          'fechaActual',
          field
        );
      }
      if (fieldCondictional) {
        this.getValueSelect(
          data,
          newCondiction,
          'txtValorAsignar',
          'txtValorAsignar_chFechaActual',
          'textSelectAsignar',
          'fechaActualAsignar',
          fieldCondictional
        );
      }
      if (!this.condictionEdit) {
        this.formsCondictions.push(newCondiction);
      } else {
        this.formsCondictions[this.indexSelected] = newCondiction;
      }
    } else {
      const newCondiction: CondicionControl = {
        campoDepende: data.cboFieldInit,
        siEs: data.cboSiEs,
        valor: data.txtValor,
        fechaActual: data['txtValor_chFechaActual'],
        accion: data.cboAction,
        valorAsignar: data.txtValorAsignar,
        fechaActualAsignar: data['txtValorAsignar_chFechaActual'],
        maestra: data.cbSelectMaestra,
        columnaMaestra: data.cbColumnaMaestra,
        columnaCondicionar: data.cbColumnaCondicionar,
        valorMaestra: data.txtValorMaestra,
        valorReferencia: data.cbValorReferencia,
        operarResultado: data.chOperarResultado,
        mantenerSesion: data.chMantenerSesion,
        validarColumna: data.chValidarColumna,
        operadorCondicion: data.cboOperactorNext
      };
      field = find(this.formulario, {alias: this.selectedFieldInit});
      fieldCondictional = find(this.formulario, {alias: this.controlCondiction.alias});
      this.getValueSelect(
        data,
        newCondiction,
        'txtValor',
        'txtValor_chFechaActual',
        'textSelect',
        'fechaActual',
        field
      );
      this.getValueSelect(
        data,
        newCondiction,
        'txtValorAsignar',
        'txtValorAsignar_chFechaActual',
        'textSelectAsignar',
        'fechaActualAsignar',
        fieldCondictional
      );
      if (!this.condictionEdit) {
        this.formulariosCondictions.push(newCondiction);
      } else {
        this.formulariosCondictions[this.indexSelected] = newCondiction;
      }
    }
    this.closeFormCondiction();
    this.loadingCondictions();
  }

  /**
   * Controla los diferentes cambios en el formulario para mostrar la informacion correcta
   *
   * @param {*} data
   * @memberof ConditionsComponent
   */
  async changeForm(data: any) {
    if (data.change && data.controlChanged !== 'txtValor' && data.controlChanged !== 'txtValorAsignar') {
      if (!this.control) {
        delete this.condictionTemp;
        this.condictionTemp = {
          formaInicia: null,
          formularioInicia: null,
          campoInicia: null,
          siEs: data.change.cboSiEs,
          valor: data.change.txtValor,
          fechaActual: data.change['txtValor_chFechaActual'],
          accion: data.change.cboAction,
          valorAsignar: data.change.txtValorAsignar,
          fechaActualAsignar: data.change['txtValorAsignar_chFechaActual'],
          formularioCondicionado: null,
          campoCondicionado: null,
          operadorCondicion: data.change.cboOperactorNext,
          maestra: data.change.cbSelectMaestra,
          columnaMaestra: data.change.cbColumnaMaestra,
          columnaCondicionar: data.change.cbColumnaCondicionar,
          valorReferencia: data.change.cbValorReferencia,
          operarResultado: data.change.chOperarResultado,
          mantenerSesion: data.chMantenerSesion,
          validarColumna: data.change.chValidarColumna,
          index: this.indexSelected,
        };
        if (this.formSelectedInit !== data.change.cboFormInit) {
          this.formSelectedInit = data.change.cboFormInit;
          this.formularioSelectedInit = null;
          this.selectedFieldInit = null;
          delete this.condictionTemp.valor;
          this.condictionTemp.formaInicia = data.change.cboFormInit;
          this.condictionTemp.formularioCondicionado = data.change.cboFormularioCondiction;
          this.condictionTemp.campoCondicionado = data.change.cboFieldCondiction;
          this.getFormulariosForm();
        } else if (this.formularioSelectedInit !== data.change.cboFormularioInit) {
          this.formularioSelectedInit = data.change.cboFormularioInit;
          this.selectedFieldInit = null;
          delete this.condictionTemp.valor;
          this.condictionTemp.formaInicia = data.change.cboFormInit;
          this.condictionTemp.formularioInicia = data.change.cboFormularioInit;
          this.condictionTemp.formularioCondicionado = data.change.cboFormularioCondiction;
          this.condictionTemp.campoCondicionado = data.change.cboFieldCondiction;
          this.getFieldForm(this.formularioSelectedInit);
        } else if (
          this.formularioSelectedCondictional !== data.change.cboFormularioCondiction
        ) {
          this.formularioSelectedCondictional = data.change.cboFormularioCondiction;
          this.condictionTemp.formaInicia = data.change.cboFormInit;
          this.condictionTemp.formularioInicia = data.change.cboFormularioInit;
          this.condictionTemp.campoInicia = data.change.cboFieldInit;
          this.condictionTemp.formularioCondicionado = data.change.cboFormularioCondiction;
          this.getFieldForm(this.formularioSelectedCondictional, 'condicionado');
        } else if (this.selectedFieldInit !== data.change.cboFieldInit) {
          this.selectedFieldInit = data.change.cboFieldInit;
          delete this.condictionTemp.valor;
          this.formularioSelectedCondictional = data.change.cboFormularioCondiction;
          this.condictionTemp.formaInicia = data.change.cboFormInit;
          this.condictionTemp.formularioInicia = data.change.cboFormularioInit;
          this.condictionTemp.campoInicia = data.change.cboFieldInit;
          this.condictionTemp.formularioCondicionado = data.change.cboFormularioCondiction;
          this.condictionTemp.campoCondicionado = data.change.cboFieldCondiction;
          await this.refreshFormCondiction();
        } else if (this.selectedFieldCondictional !== data.change.cboFieldCondiction) {
          this.selectedFieldCondictional = data.change.cboFieldCondiction;
          delete this.condictionTemp.valorAsignar;
          this.formularioSelectedCondictional = data.change.cboFormularioCondiction;
          this.condictionTemp.formaInicia = data.change.cboFormInit;
          this.condictionTemp.formularioInicia = data.change.cboFormularioInit;
          this.condictionTemp.campoInicia = data.change.cboFieldInit;
          this.condictionTemp.formularioCondicionado = data.change.cboFormularioCondiction;
          this.condictionTemp.campoCondicionado = data.change.cboFieldCondiction;
          await this.refreshFormCondiction(false, 'condicionado');
        }
      } else {
        delete this.condictionFormularioTemp;
        this.condictionFormularioTemp = {
          campoDepende: data.change.cboFieldInit,
          siEs: data.change.cboSiEs,
          valor: data.change.txtValor,
          fechaActual: data.change['txtValor_chFechaActual'],
          accion: data.change.cboAction,
          valorAsignar: data.change.txtValorAsignar,
          fechaActualAsignar: data.change['txtValorAsignar_chFechaActual'],
          operadorCondicion: data.change.cboOperactorNext,
          maestra: data.change.cbSelectMaestra,
          columnaMaestra: data.change.cbColumnaMaestra,
          columnaCondicionar: data.change.cbColumnaCondicionar,
          valorReferencia: data.change.cbValorReferencia,
          operarResultado: data.change.chOperarResultado,
          mantenerSesion: data.chMantenerSesion,
          validarColumna: data.change.chValidarColumna,
          index: this.indexSelected,
        };

        if (this.selectedFieldInit !== data.change.cboFieldInit) {
          this.selectedFieldInit = data.change.cboFieldInit;
          await this.refreshFormCondiction();
        }

        if (data.controlChanged === 'cboAction' && data.change.cboAction === 'Asignar valor') {
          delete this.condictionFormularioTemp.valorAsignar;
          delete this.condictionFormularioTemp.fechaActualAsignar;
          await this.refreshFormCondiction(false, 'condicionado');
        }
        if (data.controlChanged === 'cbSelectMaestra' && data.change.cboAction === 'Asignar valor maestra') {
          this.cfs.tablaMaestraSelectedId = data.change.cbSelectMaestra;
          if (data.change.cbSelectMaestra !== null) {
            this.tablaMaestraSelectedId = data.change.cbSelectMaestra;
            if (this.masterT !== null || this.masterT.id === this.tablaMaestraSelectedId) {
              this.masterT = await this.cds.getInformacionMasterTable(Number(data.change.cbSelectMaestra));
              this.cfs.masterTablesField = this.masterT;
              this.tablaMaestraSelectedColumnId = null;
            }
          }
          delete this.condictionFormularioTemp.valorAsignar;
          delete this.condictionFormularioTemp.fechaActualAsignar;
          await this.refreshFormCondiction(false, 'condicionado');
        }
        if (data.change.cbColumnaMaestra !== this.tablaMaestraSelectedColumnId) {
          this.cfs.tablaMaestraSelectedColumnId = this.tablaMaestraSelectedColumnId = data.change.cbColumnaMaestra;
          this.cfs.tablaMaestraSelectedColumnId = this.tablaMaestraSelectedColumnId;
        }

        if (data.change.cbColumnaCondicionar !== null ||
          this.tablaMaestraSelectedColumnId !== data.change.cbColumnaCondicionar) {
            this.columnaCondicionar = data.change.cbColumnaCondicionar;
            this.cfs.columnaCondicionar = this.columnaCondicionar;
        }
        if (data.change.cbValorReferencia !== null ||
          data.change.cbValorReferencia !== this.valorReferencia) {
            this.cfs.valorReferencia = this.valorReferencia = data.change.cbValorReferencia;
        }
        if (data.change.chOperarResultado !== null ||
          data.change.chOperarResultado !== this.operarResultado) {
            this.cfs.operarResultado = this.operarResultado = data.change.chOperarResultado;
        }
        if (data.change.chMantenerSesion !== null ||
          data.change.chMantenerSesion !== this.mantenerSesion) {
            this.cfs.mantenerSesion = this.mantenerSesion = data.change.chMantenerSesion;
        }
        if (data.change.chValidarColumna !== null ||
          data.change.chValidarColumna !== this.validarColumna) {
            this.cfs.validarColumna = this.validarColumna = data.change.chValidarColumna;
            this.conditionOperations.emit(this.validarColumna);
            await this.refreshFormCondiction(false, 'condicionado');
        }
        if (data.change.txtValorMaestra !== null ||
          data.change.txtValorMaestra !== this.valorReferencia) {
            this.cfs.valorCondicionMaestra = this.valorCondicionMaestra = data.change.txtValorMaestra;
            await this.refreshFormCondiction(false, 'condicionado');
        }
      }

      if (data.change.cboSiEs && this.selectedSiEs !== data.change.cboSiEs) {
        this.selectedSiEs = data.change.cboSiEs;
        if (!this.control) {
          this.formularioSelectedCondictional = data.change.cboFormularioCondiction;
          this.condictionTemp.formaInicia = data.change.cboFormInit;
          this.condictionTemp.formularioInicia = data.change.cboFormularioInit;
          this.condictionTemp.campoInicia = data.change.cboFieldInit;
          this.condictionTemp.formularioCondicionado = data.change.cboFormularioCondiction;
          this.condictionTemp.campoCondicionado = data.change.cboFieldCondiction;
        } else {
          if (this.condictionFormularioTemp.siEs === 'Vacio') {
            delete this.condictionFormularioTemp.valor;
          }
        }
        await this.refreshFormCondiction();
      }
    }
  }

  /**
   * Controla la respuesta de la confirmacion
   *
   * @param {boolean} res
   * @memberof ConditionsComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteCondictions();
    }
    this.question = '';
  }

  /**
   * Emite el evento de guardar las condiciones
   *
   * @memberof ConditionsComponent
   */
  saved() {
    this.saveCondictions.emit(this.formsCondictions);
  }

  /**
   * Retorna las condiciones del formulario
   *
   * @returns {Array<CondicionControl>}
   * @memberof ConditionsComponent
   */
  getCondictionsControl(): Array<CondicionControl> {
    return this.formulariosCondictions;
  }

  /**
   * Carga las condiciones para mostralas en la tabla
   *
   * @private
   * @memberof ConditionsComponent
   */
  private loadingCondictions() {
    if (!this.control) {
      this.formsCondictions.forEach((condictions, index) => {
        condictions.index = index;
        if (!condictions['textSelect']) {
          condictions['value'] = condictions.valor;
        } else {
          condictions['value'] = condictions['textSelect'];
        }
        if (!condictions['textSelectAsignar']) {
          condictions['valueAsignar'] = condictions.valorAsignar;
        } else {
          condictions['valueAsignar'] = condictions['textSelectAsignar'];
        }
      });
      this.sourceData = new LocalDataSource(this.formsCondictions);
    } else {
      this.formulariosCondictions.forEach((condictions, index) => {
        condictions.index = index;
        if (!condictions['textSelect']) {
          condictions['value'] = condictions.valor;
        } else {
          condictions['value'] = condictions['textSelect'];
        }
        if (!condictions['textSelectAsignar']) {
          condictions['valueAsignar'] = condictions.valorAsignar;
        } else {
          condictions['valueAsignar'] = condictions['textSelectAsignar'];
        }
      });
      this.sourceData = new LocalDataSource(this.formulariosCondictions);
      this.condictions.emit(this.formulariosCondictions);
    }
    this.sourceData.refresh();
  }

  /**
   * Se encarga de consultar los formularios de la forma inicial seleccionada
   * genera las opciones a seleccionar de los formularios y refresca el formulario de condicion
   *
   * @private
   * @param {boolean} [update=true]
   * @memberof ConditionsComponent
   */
  private async getFormulariosForm(update: boolean = true) {
    this.formulariosInit = [];
    delete this.options['formFormularios'];
    delete this.options['fieldInit'];
    if (this.form.alias === this.formSelectedInit) {
      this.formulariosInit = this.formCondictions;
      this.options['formFormularios'] = this.formulariosInit;
      if (update) {
        await this.refreshFormCondiction();
      } else {
        this.getFieldForm(this.formularioSelectedInit, 'inicial');
        this.getFieldForm(this.formularioSelectedCondictional, 'condicionado');
      }
    } else {
      const association = find(this.formsAssociations, {aliasAsociacion: this.formSelectedInit});
      if (association) {
        const formcondictionalSeleted = find(this.formsCondictionals, {id: association.idForma});
        if (!formcondictionalSeleted) {
          this.cds.getForm(association.idForma).subscribe(async form => {
            this.formsCondictionals.push(form);
            form.sub_formas.forEach(subForm => {
              if (subForm.alias) {
                this.formulariosInit.push({
                  key: subForm.alias,
                  value: subForm.alias,
                });
              }
            });
            this.options['formFormularios'] = this.formulariosInit;
            if (update) {
              await this.refreshFormCondiction();
            } else {
              this.getFieldForm(this.formularioSelectedInit, 'inicial');
              this.getFieldForm(this.formularioSelectedCondictional, 'condicionado');
            }
          });
        } else {
          formcondictionalSeleted.sub_formas.forEach(subForm => {
            if (subForm.alias) {
              this.formulariosInit.push({
                key: subForm.alias,
                value: subForm.alias,
              });
            }
          });
          this.options['formFormularios'] = this.formulariosInit;
          if (update) {
            this.refreshFormCondiction();
          } else {
            await this.getFieldForm(this.formularioSelectedInit, 'inicial');
            await this.getFieldForm(this.formularioSelectedCondictional, 'condicionado');
          }
        }
      } else {
        await this.refreshFormCondiction();
      }
    }
  }

  /**
   * Se encarga de consultar los campos del formulario inicial o condicionado seleccionado
   * genera las opciones a seleccionar de los campos y refresca el formulario de condicion
   *
   * @private
   * @param {string} aliasFormulario
   * @param {('inicial' | 'condicionado')} [type='inicial']
   * @param {boolean} [update=true]
   * @memberof ConditionsComponent
   */
  private async getFieldForm(
    aliasFormulario: string,
    type: 'inicial' | 'condicionado' = 'inicial',
    update: boolean = true
  ): Promise<boolean> {
    return new Promise<boolean>(async (resolve, _reject) => {
      let formulario = find(this.formularios, {alias: aliasFormulario});
      if ((!formulario || this.formSelectedInit !== this.form.alias) && type === 'inicial') {
        const association = find(this.formsAssociations, {aliasAsociacion: this.formSelectedInit});
        if (association) {
          const form = find(this.formsCondictionals, {id: association.idForma});
          if (form) {
            formulario = find(form.sub_formas, {alias: aliasFormulario});
          }
        }
      }

      if (type === 'inicial') {
        this.fieldInit = [];
      } else {
        this.fieldCondictions = [];
      }

      if (formulario) {
        formulario.campos.forEach(field => {
          if (type === 'inicial') {
            if (field.alias) {
              this.fieldInit.push({
                key: field.alias,
                value: field.alias,
              });
            }
          } else {
            if (field.alias) {
              this.fieldCondictions.push({
                key: field.alias,
                value: field.alias,
              });
            }
          }
        });
      }

      if (type === 'inicial') {
        this.options['fieldInit'] = this.fieldInit;
      } else {
        this.options['fieldCondictions'] = this.fieldCondictions;
      }
      if (update) {
        await this.refreshFormCondiction(false, type, update);
      }
      resolve(true);
    });
  }

  /**
   * Refresca el formulario
   *
   * @private
   * @param {boolean} [skitType=false]
   * @param {('inicial' | 'condicionado')} [type='inicial']
   * @param {boolean} [update=true]
   * @returns {Promise<boolean>}
   * @memberof ConditionsComponent
   */
  private refreshFormCondiction(
    skitType: boolean = false,
    type: 'inicial' | 'condicionado' = 'inicial',
    update: boolean = true
  ): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      let typeField: TipoControl;
      let typeDate: 'calendar' | 'timer' | 'dateTimer' = null;
      let field: Control;
      let formularioV = '';
      let fieldV = '';
      if (type === 'inicial') {
        if (!this.control) {
          formularioV = this.formularioSelectedInit;
        }
        fieldV = this.selectedFieldInit;
      } else {
        if (!this.control) {
          formularioV = this.formularioSelectedCondictional;
          fieldV = this.selectedFieldCondictional;
        } else {
          fieldV = this.controlCondiction.alias;
        }
      }
      if (!this.control) {
        let formulario = find(this.formularios, {alias: formularioV});
        if (!formulario) {
          const association = find(this.formsAssociations, {aliasAsociacion: this.formSelectedInit});
          if (association) {
            const form = find(this.formsCondictionals, {id: association.idForma});
            if (form) {
              formulario = find(form.sub_formas, {alias: formularioV});
            }
          }
        }
        if (formulario && fieldV) {
          const ctr = find(formulario.campos, {alias: fieldV});
          if (ctr) {
            field = ctr;
            typeField = ctr.tipo_campo;
            if (type === 'inicial') {
              this.options['typeField'] = typeField;
            } else {
              this.options['typeFieldCondiction'] = typeField;
            }
            if (ctr.propiedades && ctr.propiedades['tipo']) {
              typeDate = ctr.propiedades['tipo'];
            }
          }
        }
        if (!skitType) {
          if (field && typeField.nombre === 'ngSelect') {
            await this.loadingOptionsControl(field, type);
            resolve(true);
          } else {
            if (field && typeField.nombre === 'date-time-picker') {
              if (typeDate && typeDate !== 'dateTimer') {
                if (type === 'inicial') {
                  this.options['tipo'] = typeDate;
                } else {
                  this.options['tipoCondiction'] = typeDate;
                }
              } else {
                if (type === 'inicial') {
                  delete this.options['tipo'];
                } else {
                  delete this.options['tipoCondiction'];
                }
              }
            }
            if (update) {
              this.controls = this.cfs.getFormCondiction(
                this.ngSelectTpl,
                this.options,
                this.condictionTemp
              );
            }
            resolve(true);
          }
        } else {
          if (update) {
            this.controls = this.cfs.getFormCondiction(this.ngSelectTpl, this.options, this.condictionTemp);
          }
          resolve(true);
        }
      } else {
        field = find(this.formulario, {alias: fieldV});
        if (field) {
          typeField = field.tipo_campo;
          if (type === 'inicial') {
            this.options['typeField'] = typeField;
          } else {
            this.options['typeFieldCondiction'] = typeField;
          }
          if (field.propiedades && field.propiedades['tipo']) {
            typeDate = field.propiedades['tipo'];
          }
        }
        if (!skitType) {
          if (field && typeField.nombre === 'ngSelect') {
            await this.loadingOptionsControl(field, type);
            resolve(true);
          } else {
            if (field && typeField.nombre === 'date-time-picker') {
              if (typeDate && typeDate !== 'dateTimer') {
                if (type === 'inicial') {
                  this.options['tipo'] = typeDate;
                } else {
                  this.options['tipoCondiction'] = typeDate;
                }
              } else {
                if (type === 'inicial') {
                  delete this.options['tipo'];
                } else {
                  delete this.options['tipoCondiction'];
                }
              }
            }
            if (update) {
              this.controls = this.cfs.getFormCondictionControl(
                this.ngSelectTpl,
                this.options,
                this.condictionFormularioTemp
              );
            }
            resolve(true);
          }
        } else {
          if (update) {
            this.controls = this.cfs.getFormCondictionControl(
              this.ngSelectTpl,
              this.options,
              this.condictionFormularioTemp
            );
          }
          resolve(true);
        }
      }
    });
  }

  /**
   * Elimina el registro seleccionado de las condiciones
   *
   * @private
   * @memberof ConditionsComponent
   */
  private deleteCondictions() {
    if (!this.control) {
      this.formsCondictions.splice(this.indexSelected, 1);
    } else {
      this.formulariosCondictions.splice(this.indexSelected, 1);
    }
    this.loadingCondictions();
    this.closeFormCondiction();
  }

  /**
   * Carga los datos de la maestra del select indicado
   *
   * @private
   * @param {Control} control
   * @param {('inicial' | 'condicionado')} [type='inicial']
   * @memberof ConditionsComponent
   */
  private async loadingOptionsControl(
    control: Control,
    type: 'inicial' | 'condicionado' = 'inicial'
  ): Promise<boolean> {
    return new Promise<boolean>(async (resolve, _reject) => {
      if (control.tipo_campo.nombre === 'ngSelect') {
        const columnsMaster: Array<{
          key: string,
          value: number
        }> = [];
        if (control.propiedades.tipo === 'TablaMaestra') {
          let specificEstructure: EstructuraEspecifica;

          specificEstructure = {
            maestra: String(control.lista_maestra[0].id),
            columnas: [],
            dependencia: []
          };

          let columns: ValoresEspecificos[];

          const colsMaster = find(this.acomulateColumns, {name: control.nombre_campo});
          if (!colsMaster) {
            control.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
              const cols = col.split('_');
              const column = Number(cols[0]);
              if (cols.length === 1) {
                const structure = find(control.lista_maestra[0].estructura, {id: column});
                if (structure) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            });

            if (control.propiedades['columnas_seleccionadas'].length) {
              const blockColumns: Array<string[]> = [];
              if (control.propiedades['columnas_seleccionadas']) {
                let columnDependence = '';
                control.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
                  const column = col.split('_');
                  if (column.length > 1) {
                    if (columnDependence !== column[0]) {
                      columnDependence = column[0];
                      const blockColumnsRecolector: Array<string> = [];
                      control.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
                        const columnsRef = colDep.split('_');
                        if (columnsRef[0] === columnDependence) {
                          blockColumnsRecolector.push(colDep);
                        }
                      });
                      blockColumns.push(blockColumnsRecolector);
                    }
                  }
                });
                blockColumns.forEach(columnsSeleted => {
                  const history = this.loadingEstructureColumns(
                    control.lista_maestra[0]['estructura'],
                    columnsSeleted,
                    Number(columnsSeleted[0].split('_')[0])
                  );

                  if (history) {
                      specificEstructure.dependencia.push(history);
                  }
                });
              }
            }
            columns = await this.cds.getColumnsSpecificMasterTable(specificEstructure);

            this.acomulateColumns.push({
              name: control.nombre_campo,
              columns: columns
            });
          } else {
            columns = colsMaster.columns;
          }

          columns.forEach(column => {
            let labelSelect = '';
            control.propiedades['columnas_seleccionadas'].forEach((col: number, index: any) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (column.valores[col]) {
                labelSelect += column.valores[col] ;
              } else {
                labelSelect += 'No aplica';
              }
            });
            columnsMaster.push({value: column.id, key: labelSelect});
          });
          // control.propiedades['options'] = columnsMaster;
          if (type === 'inicial') {
            this.options['optColumnMaster'] = columnsMaster;
          } else {
            this.options['optColumnMasterCondiction'] = columnsMaster;
          }
          await this.refreshFormCondiction(true, type);
          resolve(true);
        } else {
          if (type === 'inicial') {
            delete this.options['optColumnMaster'];
          } else {
            delete this.options['optColumnMasterCondiction'];
          }
          await this.refreshFormCondiction(true, type);
          resolve(true);
        }
      } else {
        if (type === 'inicial') {
          delete this.options['optColumnMaster'];
        } else {
          delete this.options['optColumnMasterCondiction'];
        }
        await this.refreshFormCondiction(true, type);
        resolve(true);
      }
    });
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof ConditionsComponent
   */
  private loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };
    columns.forEach(el => {
      cls.push(el);
    });
    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const  cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, {id: column});
                if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Obtiene el label de la opción seleccionada
   *
   * @private
   * @param {*} data
   * @param {(CondicionForma | CondicionControl)} newCondiction
   * @param {string} fielValue
   * @param {string} dateValue
   * @param {string} columnCondiction
   * @param {string} columnDate
   * @param {Control} [field]
   * @memberof ConditionsComponent
   */
  private getValueSelect(
    data: any,
    newCondiction: CondicionForma | CondicionControl,
    fielValue: string,
    dateValue: string,
    columnCondiction: string,
    columnDate: string,
    field?: Control
  ) {
    const moment = require('moment');
    let date = false;
    if (data[fielValue] && moment(new Date(data[fielValue])).isValid()) {
      date = true;
    } else if (data[dateValue]) {
      date = true;
    }
    if (field) {
      if (field.tipo_campo && field.tipo_campo.nombre === 'ngSelect') {
        const rows = find(this.acomulateColumns, {name: field.nombre_campo});
        if (rows) {
          const valor = find(rows.columns, {id: data[fielValue]});
          let labelSelect = '';
          if (valor) {
            field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (valor.valores[col]) {
                labelSelect += valor.valores[col];
              } else {
                labelSelect += 'No aplica';
              }
            });
          }
          newCondiction[columnCondiction] = labelSelect;
        }
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
        if (data[fielValue] === 'true') {
          newCondiction[columnCondiction] = 'Seleccionado';
        } else {
          newCondiction[columnCondiction] = 'No seleccionado';
        }
      } else if (date && (data[fielValue] instanceof Date || field.tipo_campo.nombre === 'date-time-picker')) {
        const dateValor: Date = new Date(data[fielValue]);
        if (
          typeof field.tipo_campo === 'object' &&
          field.tipo_campo.nombre === 'date-time-picker' &&
          field.propiedades &&
          field.propiedades['tipo']
        ) {
          if (moment(String(dateValor)).isValid()) {
            dateValor.setSeconds(0, 0);
            switch (field.propiedades['tipo']) {
              case 'calendar':
                newCondiction[columnCondiction] = dateValor.toLocaleDateString();
                break;
              case 'timer':
                newCondiction[columnCondiction] = dateValor.toLocaleTimeString();
                break;
              default:
                newCondiction[columnCondiction] = dateValor.toLocaleDateString() + ' ' + dateValor.toLocaleTimeString();
                break;
            }
          } else {
            if (newCondiction[columnDate]) {
              newCondiction[columnCondiction] = 'Fecha actual';
            }
          }
        } else {
          if (moment(String(dateValor)).isValid()) {
            dateValor.setSeconds(0, 0);
            newCondiction[columnCondiction] = dateValor.toLocaleDateString() + ' ' + dateValor.toLocaleTimeString();
          } else {
            if (newCondiction[columnDate]) {
              newCondiction[columnCondiction] = 'Fecha actual';
            }
          }
        }
        if (moment(String(dateValor)).isValid()) {
          newCondiction[fielValue] = dateValor;
        } else {
          if (newCondiction[columnDate]) {
            newCondiction[columnCondiction] = 'Fecha actual';
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/conditions/conditions.component.ts